export default {
  page: {
    title: "Contact",
    bannerSubtitle: "Ask us anything — product inquiries, quote requests, technical consultation, and more",
    submittedSubtitle: "Your inquiry has been received",
    submittedTitle: "Inquiry Received",
    submittedDesc: "Thank you for your inquiry. Our team will review it and respond as soon as possible. For urgent matters, please contact us by phone.",
    contactInfoTitle: "Contact Information",
    contactInfoDesc: "You may also reach us directly by phone or email. Feel free to contact us using the details below.",
    tel: "Phone",
    fax: "Fax",
    email: "Email",
    address: "Address",
    onlineTitle: "Online Inquiry",
    onlineDesc: "Fill out the form below and our team will get back to you.",
    form: {
      company: "Company",
      companyPlaceholder: "Enter your company name",
      name: "Contact Person",
      namePlaceholder: "Enter the contact person's name",
      phone: "Phone",
      phonePlaceholder: "Enter your phone number",
      email: "Email",
      emailPlaceholder: "Enter your email",
      inquiryType: "Inquiry Type",
      inquiryTypePlaceholder: "Select an inquiry type",
      inquiryTypes: [
        { value: "product", label: "Product Inquiry" },
        { value: "quotation", label: "Quote Request" },
        { value: "technical", label: "Technical Consultation" },
        { value: "sample", label: "Sample Request" },
        { value: "other", label: "Other" },
      ],
      message: "Message",
      messagePlaceholder: "Please describe your inquiry in detail. (Product use, required quantity, application environment, etc.)",
      messageHint: "Up to 500 characters.",
      attachment: "Attachment (drawings, photos, etc.)",
      attachmentHint: "PDF, JPG, PNG, DWG files accepted (up to 10MB)",
      consent: "I agree to the collection and use of my personal information. The collected information is used solely for responding to this inquiry and is stored securely in accordance with relevant laws.",
      submit: "Submit Inquiry",
      submitting: "Submitting...",
    },
  },
};